import { PropsWithChildren } from 'react';

import { Provider, getOrganizationQp } from '@common/libs/auth';
import { Loader } from '@common/ui/Loader';

import { useCheckAuthentication } from './use-check-auth.hook';

export function AuthProvider({ children }: PropsWithChildren<unknown>) {
  const fronteggContext = {
    baseUrl: FRONTEGG_URL || '',
    clientId: FRONTEGG_CLIENT_ID || '',
    tenantResolver,
  };

  const fronteggAuth = {
    keepSessionAlive: true,
  };

  function tenantResolver() {
    return {
      tenant: getOrganizationQp(),
    };
  }

  return (
    <>
      <Provider contextOptions={fronteggContext} authOptions={fronteggAuth} customLoader={true} hostedLoginBox={false}>
        {children}
      </Provider>
    </>
  );
}

export function CheckAuthentication({ children }: PropsWithChildren<unknown>) {
  const isAuthenticated = useCheckAuthentication();

  return isAuthenticated ? <>{children}</> : <Loader />;
}

export function Authenticated({ children }: PropsWithChildren<unknown>) {
  return (
    <AuthProvider>
      <CheckAuthentication>{children}</CheckAuthentication>
    </AuthProvider>
  );
}
